import React, { useMemo } from 'react';
import { TermItem } from '../../graphql/graphql';
import { formatInsuranceCompany } from '../../Modules/Manager/Helpers/InsuranceCompanies/formatInsuranceCompaniesOptions';

interface Props {
	insuranceCompanyTermItem?: TermItem;
	showName?: boolean;
}

const InsuranceCompanyDisplay = ({
	insuranceCompanyTermItem,
	showName,
}: Props) => {
	const insuranceCompany = useMemo(
		() => formatInsuranceCompany(insuranceCompanyTermItem, showName),
		[insuranceCompanyTermItem, showName],
	);

	if (!(insuranceCompanyTermItem?.value && insuranceCompanyTermItem?.value2)) {
		return <></>;
	}

	return <span style={{ color: 'inherit' }}>{insuranceCompany}</span>;
};

export default InsuranceCompanyDisplay;
